import React from "react";
import {
  Layout,
  message,
  Card,
  Row,
  Col,
  Modal,
  Button,
  Spin,
  Menu,
  Input,
  Select,
  Empty,
  Icon,
} from "antd";
import AliceCarousel from "react-alice-carousel";
import moment from "moment";
import TierProfile from "../../elements/TierProfile";
import TableWrapper from "../../elements/TableWrapper";
import MiCompAPI from "../../../util/api";
import MassProfileAssgin from "./Mass_profile_assgin";
import UserAddress from "../UserAddress";

const { Content } = Layout;
const { Option } = Select;
class Client extends React.Component {
  profile_columns = [
    {
      title: "Profile Name",
      dataIndex: "tier_profile_name",
      sorter: (a, b) => a.tier_profile_name.localeCompare(b.tier_profile_name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      render: (text, record) =>
        moment(record["start_date"]).format("MM/DD/YYYY"),
      sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      render: (text, record) => moment(record["end_date"]).format("MM/DD/YYYY"),
      sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Reimbursement Type",
      dataIndex: "reimb_type_name",
      sorter: (a, b) => a.reimb_type_name.localeCompare(b.reimb_type_name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Action",
      dataIndex: "",
      render: (record) => (
        <>
          {" "}
          <i
            className="fa fa-eye fa-b"
            onClick={() => {
              this.UserDefaultHandler(record);
            }}
          />{" "}
        </>
      ),
    },
  ];
  constructor(props) {
    super(props);
    let _client_id =
      this.props.location && this.props.location.state
        ? this.props.location.state["client_id"]
        : 0;
    this.state = {
      lob: "0",
      search_val: null,
      client_id: _client_id,
      client: null,
      slideToIndex: 0,
      Client_Tiers: null,
      Tier_Profiles: [],
      errors: null,
      filedata: null,
      loadingp: true,
      loadingpf: true,
      record: [],
      isProfileShow: false,
      currentTab: _client_id === 0 ? "plan" : "general",
      Act_Client_Tiers: null,
      lobs: [],
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    this.getClient();
    this.getClient_Tiers();
    this.getClientMasters();
  };
  UserDefaultHandler = (record) => {
    this.setState({
      record,
      isProfileShow: !this.state.isProfileShow,
    });
  };
  handleClick = (e) => {
    this.setState({
      currentTab: e.key,
    });
  };
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            lobs: data.lobs,
          });
        }
      },
      ["LOB"]
    );
  }
  getClient_Tiers() {
    this.api.invoke(
      "GetAllClient_TierByClientId/" + this.state.client_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              Client_Tiers: data.data.map((x) => ({
                ...x,
                isActiveTab: false,
              })),
              Act_Client_Tiers: data.data.map((x) => ({
                ...x,
                isActiveTab: false,
              })),
              loadingp: false,
            });
            this.getTier_Profiles(data.data[0].tier_id);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }
  uploadPlans = () => {
    if (this.state.filedata) {
      if (
        this.state.filedata.docName.split(".")[1] === "xls" ||
        this.state.filedata.docName.split(".")[1] === "xlsx"
      ) {
        this.api.invoke(
          "ImportTierandProfile",
          "post",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                document.getElementById("files").value = "";
                message.destroy();
                message.success(data.statusMessage, 3);
                this.setState({
                  errors: null,
                  filedata: null,
                });
                this.getClient_Tiers();
              } else {
                this.setState({
                  errors: data.data,
                });
                message.destroy();
                message.error(data.statusMessage, 3);
              }
            }
          },
          this.state.filedata
        );
      } else {
        message.error(
          "Invalid File Format!, Please upload xls or xlsx File",
          3
        );
      }
    } else {
      message.destroy();
      message.error("Please select file to upload", 3);
    }
  };
  handleAddDocument = async (evt) => {
    var f = evt.target.files[0];
    if (f.name.split(".")[1] !== "xls" && f.name.split(".")[1] !== "xlsx") {
      message.error("Invalid File Format!, Please upload xls or xlsx File", 3);
    }
    this.setState({
      filedata: {
        base64file: await this.convertBase64(f),
        docName: f.name,
      },
    });
  };
  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  getTier_Profiles = (tier_id) => {
    this.setState({
      loadingpf: true,
      Client_Tiers: this.state.Client_Tiers.map((x, index) => {
        if (x.tier_id === tier_id) {
          this.setState({
            slideToIndex: index,
          });
          return { ...x, isActiveTab: true };
        } else {
          return { ...x, isActiveTab: false };
        }
      }),
    });
    this.api.invoke(
      "GetAllClient_Tier_ProfileByTierId/" + tier_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              Tier_Profiles: data.data,
              loadingpf: false,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  getClient() {
    this.api.invoke(
      "GetClientById/" + this.state.client_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              client: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }
  MassAssignProfile = (data,e) => {    
    if(e==='old'){
      this.api.invoke(
        "MassAndProfile_Assign",
        "post",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          } else {
          }
        },
        {...data,client_id:this.state.client_id}
      );
    }
    else{
      this.api.invoke(
        "MassProfile_AssignNew",
        "post",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          } else {
          }
        },
        {...data,client_id:this.state.client_id}
      );
    }
    
  };
  search = (type, value) => {
    if (type === "lob") {
      this.setState({
        lob: value,
      });
    }
    if (type === "sea") {
      this.setState({
        search_val: value.target.value,
      });
    }
    setTimeout(() => {
      var data;
      if (this.state.search_val) {
        data = this.state.Act_Client_Tiers.filter((o) =>
          Object.keys(o).some((k) =>
            String(o[k])
              .toLowerCase()
              .includes(this.state.search_val.toLowerCase())
          )
        );
      } else {
        data = this.state.Act_Client_Tiers;
      }
      if (this.state.lob === "0") {
        this.setState({
          Client_Tiers: data,
        });
      } else if (this.state.lob === "") {
        this.setState({
          Client_Tiers: data.filter((o) => {
            if (o.lob === "" || o.lob === null) {
              return o;
            }
            return null;
          }),
        });
      } else {
        this.setState({
          Client_Tiers: data.filter((o) => {
            if (o.lob === this.state.lob) {
              return o;
            }
            return null;
          }),
        });
      }
      if (this.state.Client_Tiers && this.state.Client_Tiers.length > 0)
        this.getTier_Profiles(this.state.Client_Tiers[0].tier_id);
    }, 1);
  };
  searchtext = (value) => {
    this.setState({
      Client_Tiers: this.state.Act_Client_Tiers.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.target.value.toLowerCase())
        )
      ),
    });
    if (this.state.Client_Tiers && this.state.Client_Tiers.length > 0)
      this.getTier_Profiles(this.state.Client_Tiers[0].tier_id);
  };
  getSelectedTabView() {
    if (this.state.isLoading) {
      return (
        <Card
          style={{
            minHeight: "100vh",
            background: "#f0f0f0",
            textAlign: "center",
          }}
        >
          <Spin size="large" />
        </Card>
      );
    }
    switch (this.state.currentTab) {
      case "general":
        let personalDetailsCard, addressCard;
        if (this.state.client && this.state.client.client) {
          personalDetailsCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={15}>
                  <p className="mi_title" style={{ color: "#fd828d" }}>
                    Personal Details{" "}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <p className="mi_name">Company Name</p>
                  <p className="mi_value">
                    {this.state.client.client.client_name
                      ? this.state.client.client.client_name
                      : "none"}
                  </p>
                </Col>
                <Col md={12} sm={24}>
                  <p className="mi_name">Primary Contact Name</p>
                  <p className="mi_value">
                    {(this.state.client.client.primary_Contact_Last_Name
                      ? this.state.client.client.primary_Contact_Last_Name
                      : "") +
                      " " +
                      (this.state.client.client.primary_Contact_Middle_Name
                        ? this.state.client.client.primary_Contact_Middle_Name
                        : "") +
                      " " +
                      (this.state.client.client.primary_Contact_First_Name
                        ? this.state.client.client.primary_Contact_First_Name
                        : "")}
                  </p>{" "}
                </Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <p className="mi_name">Contact Title</p>
                  <p className="mi_value">
                    {this.state.client.client &&
                    this.state.client.client.contact_Title
                      ? this.state.client.client.contact_Title
                      : "None"}
                  </p>
                </Col>
                <Col md={12} sm={24}>
                  <p className="mi_name">Email</p>
                  <p className="mi_value">
                    {this.state.client.client && this.state.client.client.email
                      ? this.state.client.client.email
                      : "None"}
                  </p>
                </Col>
                <Col md={12} sm={24}>
                  <p className="mi_name"> Contact Number</p>
                  <p className="mi_value">
                    {this.state.client.client.primary_Contact_Phone &&
                    this.state.client.client.primary_Contact_Phone.length ===
                      17 ? (
                      <a
                        href={
                          "tel:+" +
                          this.state.client.client.primary_Contact_Phone
                        }
                      >
                        {this.state.client.client.primary_Contact_Phone}
                      </a>
                    ) : (
                      "Invalid US Number"
                    )}
                  </p>
                </Col>
                <Col md={12} sm={24}>
                  <p className="mi_name">Extension</p>
                  <p className="mi_value">
                    {this.state.client.client &&
                    this.state.client.client.extension
                      ? this.state.client.client.extension
                      : "none"}
                  </p>
                </Col>
                <Col md={12} sm={24}>
                  <p className="mi_name">Tax Id</p>
                  <p className="mi_value">
                    {this.state.client.client &&
                    this.state.client.client.client_tax_id
                      ? this.state.client.client.client_tax_id.length === 10
                        ? this.state.client.client.client_tax_id
                        : "Invalid Tax Id"
                      : "None"}
                  </p>
                </Col>
              </Row>
              <Row span={24}>
                <Col span={24}>
                  <p className="mi_title" style={{ color: "#fd828d" }}>
                    LOA{" "}
                  </p>
                </Col>
                <Col span={24} style={{ display: "flex" }}>
                  {this.state.client && this.state.client.loas
                    ? this.state.client.loas.map((iteam) => {
                        return (
                          <>
                            {" "}
                            <p className="mi_value">{iteam}</p>
                          </>
                        );
                      })
                    : "None"}
                </Col>
              </Row>
            </div>
          );
          addressCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={15}>
                  <p className="mi_title" style={{ color: "#fd828d" }}>
                    Address
                  </p>
                </Col>
                <Col span={9}></Col>
              </Row>
              <UserAddress address={this.state.client.address}></UserAddress>
            </div>
          );
        }

        return (
          <Row span={24}>
            <Col md={24} sm={24}>
              {personalDetailsCard}
            </Col>
            <Col md={24} sm={24}>
              {addressCard}
            </Col>
          </Row>
        );
      case "plan": {
        return (
          <div>
            <Row style={{ marginBottom: "20px" }}>
              <Col md={8} sm={24}></Col>
              <Col md={16} sm={24}>
                <Row>
                  <Col md={12} sm={24}>
                    <div
                      style={{
                        float: "right",
                        marginTop: "8px",
                        marginLeft: "20px",                       
                      }}
                    >
                      <fieldset className="mi_input_pop">
                        <legend className="legend-font">LOA</legend>
                        <Select
                          suffixIcon={
                            <Icon
                              style={{ transform: "rotate(90deg)" }}
                              type="double-right"
                            />
                          }
                          className="mi_input"
                          style={{ width: "230px", marginRight: "8px" }}
                          showSearch={true}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          onChange={this.search.bind(this, "lob")}
                          placeholder="Please Select LOA *"
                        >
                          <Option value="0" key="0">
                            None
                          </Option>
                          {this.state.lobs.map((tag) => (
                            <Option value={tag.name} key={tag.name}>
                              {tag.name}
                            </Option>
                          ))}
                        </Select>
                      </fieldset>
                    </div>
                  </Col>
                  <Col md={12} sm={24}>
                    <div
                      style={{
                        float: "right",
                        marginTop: "8px",
                        marginLeft: "20px",
                        marginRight:"10px",
                      }}
                    >
                      <Input.Search
                        style={{
                          marginTop: "22px",
                          marginRight: "5px",
                          width: "330px",
                        }}
                        placeholder="Search "
                        className="table-search-button"
                        onChange={this.search.bind(this, "sea")}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {!this.props.isprofile ? (
              <Row span={24}>
                <Col span={24}>
                  <Button
                    style={{ float: "right",marginRight:"11px"}}
                    className="mi_button_right submit-button"
                    type="primary"
                    onClick={() =>
                      this.props.history.push({
                        pathname:
                          "/tier/addprofile/" + this.state.client_id + "/0",
                        state: { client_id: this.state.client_id, tier_id: 0 },
                      })
                    }
                  >
                    Add Plan
                  </Button>
                </Col>
              </Row>
            ) : (
              ""
            )}
            <Row span={24}>
              {(this.state.Client_Tiers &&
                this.state.Client_Tiers.length > 3) ||
              window.innerWidth < 760 ? (
                <AliceCarousel
                  startIndex={this.state.slideToIndex}
                  stopAutoPlayOnHover={false}
                  responsive={{
                    0: { items: 1 },
                    1024: { items: 3 },
                  }}
                  dotsDisabled={true}
                >
                  {this.state.Client_Tiers.map((item) => {
                    return (
                      <Col>
                        <div
                          className={
                            item.isActiveTab ? "Rectangle-1" : "Rectangle-3"
                          }
                          onClick={() => this.getTier_Profiles(item.tier_id)}
                        >
                          <div style={{ transform: "rotate(180deg)" }}>
                            <Row span={24}>
                              <Col span={15}>
                                <p className="mi_plan_title">
                                  {item.plan_Name}{" "}
                                </p>
                              </Col>
                              <Col span={9}>
                                <p className="mi_plan_badge">
                                  {"id : " + item.client_plan_Id}
                                </p>
                              </Col>
                            </Row>
                            <Row span={24}>
                              <Col span={12}>
                                <p className="mi_plan_start">
                                  {item.start_date
                                    ? "Start date : " +
                                      moment(item.start_date).format(
                                        "MM/DD/YYYY"
                                      )
                                    : "none"}{" "}
                                </p>
                              </Col>
                              <Col span={12}>
                                <p
                                  className="mi_plan_start"
                                  style={{ float: "right", height: "24px" }}
                                >
                                  {item.end_date
                                    ? "End date : " +
                                      moment(item.end_date).format("MM/DD/YYYY")
                                    : "none"}
                                </p>
                              </Col>
                            </Row>
                            <Row span={24}>
                              {!this.props.isprofile ? (
                                <Button
                                  style={{
                                    float: "right",
                                    height: "30px",
                                    width: "80px",
                                  }}
                                  className="mi_button_right"
                                  type="primary"
                                  onClick={() =>
                                    this.props.history.push({
                                      pathname:
                                        "/tier/addprofile/" +
                                        this.state.client_id +
                                        "/" +
                                        item.tier_id,
                                      state: {
                                        client_id: this.state.client_id,
                                        tier_id: item.tier_id,
                                      },
                                    })
                                  }
                                >
                                  Edit
                                </Button>
                              ) : (
                                ""
                              )}
                            </Row>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </AliceCarousel>
              ) : this.state.Client_Tiers ? (
                this.state.Client_Tiers.map((item) => {
                  return (
                    <Col key={item.tier_id} md={8}>
                      <div
                        className={
                          item.isActiveTab ? "Rectangle-1" : "Rectangle-3"
                        }
                        onClick={() => this.getTier_Profiles(item.tier_id)}
                      >
                        <div style={{ transform: "rotate(180deg)" }}>
                          <Row span={24}>
                            <Col span={15}>
                              <p className="mi_plan_title">{item.plan_Name} </p>
                            </Col>
                            <Col span={9}>
                              <p className="mi_plan_badge">
                                {"id : " + item.client_plan_Id}
                              </p>
                            </Col>
                          </Row>
                          <Row span={24}>
                            <Col span={12}>
                              <p className="mi_plan_start">
                                {item.start_date
                                  ? "Start date : " +
                                    moment(item.start_date).format("MM/DD/YYYY")
                                  : "none"}{" "}
                              </p>
                            </Col>
                            <Col span={12}>
                              <p
                                className="mi_plan_start"
                                style={{ float: "right" }}
                              >
                                {item.end_date
                                  ? "End date : " +
                                    moment(item.end_date).format("MM/DD/YYYY")
                                  : "none"}
                              </p>
                            </Col>
                          </Row>
                          <Row span={24}>
                            {!this.props.isprofile ? (
                              <Button
                                style={{
                                  float: "right",
                                  height: "30px",
                                  width: "80px",
                                }}
                                className="mi_button_right"
                                type="primary"
                                onClick={() =>
                                  this.props.history.push({
                                    pathname:
                                      "/tier/addprofile/" +
                                      this.state.client_id +
                                      "/" +
                                      item.tier_id,
                                    state: {
                                      client_id: this.state.client_id,
                                      tier_id: item.tier_id,
                                    },
                                  })
                                }
                              >
                                Edit
                              </Button>
                            ) : (
                              ""
                            )}
                          </Row>
                        </div>
                      </div>
                    </Col>
                  );
                })
              ) : (
                <Empty />
              )}
            </Row>
            <Row style={{ paddingLeft: "12px",paddingRight:"12px" }}>
              {this.state.Client_Tiers && this.state.Client_Tiers.length ? (
                <TableWrapper
                  rowKey="tier_profile_id"
                  title="Profiles"
                  columns={this.profile_columns}
                  data={this.state.Tier_Profiles}
                  loading={this.state.loadingpf}
                />
              ) : (
                <Empty />
              )}
              {!this.props.isprofile ? (
                <Row span={24} style={{ marginTop: "30px",marginLeft:"8px" }}>
                  <Col span={24}>
                    <input
                      type="file"
                      id="files"
                      name="files"
                      onChange={this.handleAddDocument}
                    />
                    <Button
                      type="primary"
                      style={{ width: "250px", height: "40px" }}
                      onClick={this.uploadPlans}
                    >
                      <i className="fa fa-upload" aria-hidden="true"></i>
                      Upload Incentive Profiles
                    </Button>
                    <Button
                      type="primary"
                      style={{
                        marginTop: "10px",
                        width: "250px",
                        height: "40px",
                      }}
                      onClick={() =>
                        window.open(
                          process.env.REACT_APP_SAMPLE_URL+"samplefiles/PlanandProfile.xlsx",
                          "_blank"
                        )
                      }
                    >
                      <i className="fa fa-download" aria-hidden="true"></i>
                      Sample Document
                    </Button>
                  </Col>
                </Row>
              ) : (
                ""
              )}
              <Row span={24}>
                <Col span={24}>
                  {this.state.errors ? (
                    <div className="mi_well">
                      {this.state.errors.map((element) => {
                        return <p className="mi_wepp_p">{element}</p>;
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </Row>
          </div>
        );
      }
      case "assgin": {
        return (
          <div className="mi_main">
            <MassProfileAssgin
              client_id={this.state.client_id}
              submitHandler={this.MassAssignProfile}
            />
          </div>
        );
      }
      default:
        return <></>;
    }
  }
  render() {
    return (
      <Content>
        {this.state.isProfileShow ? (
          <Modal visible={this.state.isProfileShow}>
            {" "}
            <TierProfile
              Client_Tier={this.state.record.client_TierADataModel}
              title="Profile Details"
              Tier_Profile={this.state.record}
              closeDrawerHandler={() => {
                this.UserDefaultHandler(null);
              }}
            />
          </Modal>
        ) : null}
        <div className="mi_main_div">
          <Menu
            className="mi_general_bar"
            style={{ width: "fit-content" }}
            onClick={this.handleClick}
            selectedKeys={[this.state.currentTab]}
            mode="horizontal"
          >
            {this.props.isprofile ? (
              <Menu.Item className="mi_menu_item" key="general">
                General
              </Menu.Item>
            ) : (
              ""
            )}
            <Menu.Item className="mi_menu_item" key="plan">
              Plans and Profiles
            </Menu.Item>
            {!this.props.isprofile ? (
              <Menu.Item className="mi_menu_item" key="assgin">
                Profile Assignment
              </Menu.Item>
            ) : (
              ""
            )}
          </Menu>
          {this.getSelectedTabView()}
        </div>
      </Content>
    );
  }
}
export default Client;
